'use client';
import { demoSuggestions } from '@slims/shared/data';
import { useMemo } from 'react';
import { ADMIN_RECS } from '@/lib/admin-recs';
import { useScopeTree } from './use-scope-tree';

export function useAdminRecommendations(tenantId: string | undefined) {
	const { leaves } = useScopeTree();
	const features = leaves.find((s) => s.tenantId === tenantId)?.features;
	const day = new Date().toISOString().slice(0, 10);
	return useMemo(() => {
		// Il catalogo è contenuto dimostrativo: date fisse, uguale per tutti i soci.
		// Si mostra solo in modalità demo, etichettato «Esempio»; in modalità
		// attiva le raccomandazioni sono il piano giornaliero calcolato sui dati
		// (`useDailyRecommendations`, INB-355).
		if (!features || features.aiSuggestions !== 'demo') return [];
		const recs = ADMIN_RECS.filter((r) => features.anomalies || r.category !== 'manutenzione');
		return demoSuggestions(recs, tenantId ?? '', day);
	}, [features, tenantId, day]);
}
